
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M13.5 24a2.227 2.227 0 01-1.5-.575 2.227 2.227 0 01-1.5.575h-6a2.252 2.252 0 01-2.25-2.25V2.25A2.252 2.252 0 014.5 0h6c.563 0 1.091.206 1.5.575A2.227 2.227 0 0113.5 0h6a2.252 2.252 0 012.25 2.25v19.5A2.252 2.252 0 0119.5 24h-6zm0-22.5a.75.75 0 00-.75.75v19.5c0 .414.336.75.75.75h6a.75.75 0 00.75-.75V2.25a.75.75 0 00-.75-.75h-6zm-9 0a.75.75 0 00-.75.75v19.5c0 .414.336.75.75.75h6a.75.75 0 00.75-.75V2.25a.75.75 0 00-.75-.75h-6z"}}),_c('path',{attrs:{"d":"M16.5 21c-1.241 0-2.25-1.009-2.25-2.25s1.009-2.25 2.25-2.25 2.25 1.009 2.25 2.25S17.741 21 16.5 21zm0-3a.75.75 0 100 1.5.75.75 0 000-1.5zM7.5 21c-1.241 0-2.25-1.009-2.25-2.25S6.259 16.5 7.5 16.5s2.25 1.009 2.25 2.25S8.741 21 7.5 21zm0-3a.75.75 0 100 1.5.75.75 0 000-1.5zM6.5 15c-.689 0-1.25-.561-1.25-1.25V5c0-.689.561-1.25 1.25-1.25h2c.689 0 1.25.561 1.25 1.25v8.75c0 .689-.561 1.25-1.25 1.25h-2zm1.75-1.5V5.25h-1.5v8.25h1.5zM15.5 15c-.689 0-1.25-.561-1.25-1.25V5c0-.689.561-1.25 1.25-1.25h2c.689 0 1.25.561 1.25 1.25v8.75c0 .689-.561 1.25-1.25 1.25h-2zm1.75-1.5V5.25h-1.5v8.25h1.5z"}})])
          )
        }
      }
    